import { render, staticRenderFns } from "./CategoryNavigationMenuItem.vue?vue&type=template&id=55b7d14c&scoped=true&"
import script from "./CategoryNavigationMenuItem.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigationMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigationMenuItem.vue?vue&type=style&index=0&id=55b7d14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7d14c",
  null
  
)

export default component.exports